
import React, { useEffect, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import * as bie from "react-bootstrap";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { TableContainer, Table, TableBody, TableHead, TableRow, TableCell, Paper } from "@mui/material";
import { Field, Form, FormikProvider, useFormik } from "formik";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
const COLORSPie = {
    Ongoing: "#FFA726",
    "Bills Pending": "#EF5350",
    Completed: "#66BB6A",
};

// normalize inconsistent API project_status values
const normalizeStatus = (s = "") => {
    s = s.trim().toLowerCase();
    if (s.includes("ongoing")) return "Ongoing";
    if (s.includes("bill")) return "Bills Pending";
    if (s.includes("completed")) return "Completed";
    return "";
};

export default function DistiwiseDataRepresentation({ rusaPhase }) {
    const [distlist, setDistlist] = useState([]);
    const [distname, setDistname] = useState("");
    const [distpiedata, setDistpiedata] = useState([]);
    const [colleges, setColleges] = useState([]);
    const [activeTab, setActiveTab] = useState("Ongoing");

    const DistFomik = useFormik({
        initialValues: {
            dist: "",

        },

    });

    // ---------------- DISTRICT LIST ----------------
    const fetchDistList = async () => {
        const res = await CommonAxiosGet(
            `${config.url.API_URL}getDistrictsUsha`
        );
        setDistlist(res?.data?.scode === "01" ? res.data.getDistricts : []);
    };

    // ---------------- PIE + COLLEGE DATA ----------------
    const [Errormsg, seterrormsg] = useState(null);

    function fetchDistData(district) {
        if (!district) {
            return;
        }

        const url = `${config.url.API_URL}getDistwiseProjectStatus?distCode=${encodeURIComponent(district)}&rusa_phase=${encodeURIComponent(rusaPhase)}`;

        CommonAxiosGet(url).then((res) => {
            const data = res?.data;
            if (data?.DistProjectStatus_status === false) {
                seterrormsg(false);
            }

            if (data?.scode !== "01") {
                setDistpiedata([]);
                setColleges([]);
                seterrormsg(false);
                return;
            }

            const d = data?.DistProjectStatus?.[0] || {};
            setDistname(d?.dist);

            // pie counts
            setDistpiedata([
                { project_status: "Ongoing", count: d?.ongoing || 0 },
                { project_status: "Bills Pending", count: d?.bills_pending || 0 },
                { project_status: "Completed", count: d?.completed || 0 },
            ]);

            // normalize college list
            setColleges(
                (Array.isArray(data?.data) ? data.data : []).map((c) => ({
                    ...c,
                    status: normalizeStatus(c.project_status),
                }))
            );

            setActiveTab("Ongoing");
        });
    }

    const hcSeriesData = distpiedata?.map(item => ({
        name: item.project_status,
        y: item.count === 0 ? 0.01 : item.count,   // 🔑 same trick as Recharts
        actualCount: item.count,
        color: COLORSPie[item.project_status],
    }));
    const pieOptions = {
        chart: {
            type: "pie",
            height: 300,
            width: 300
        },

        title: {
            text: null
        },

        tooltip: {
            formatter: function () {
                return `
                <b>${this.point.name}</b><br/>Count: ${this.point.actualCount}`; // NOSONAR - Highcharts formatter requires 'this' context
            }
        },

        plotOptions: {
            pie: {
                innerSize: "55%",       // innerRadius = 60
                size: "90%",            // outerRadius = 110 (relative)
                padding: 3,
                dataLabels: {
                    enabled: false
                }
            }
        },

        legend: {
            enabled: false   // ❗ using custom legend
        },

        series: [
            {
                name: "Projects",
                data: hcSeriesData
            }
        ],

        credits: {
            enabled: false
        }
    };
    useEffect(() => {
        fetchDistList();
    }, []);
    return (

        <>
            <FormikProvider value={DistFomik}>
                <Form onSubmit={DistFomik.handleSubmit} onChange={DistFomik.onChange}>

                    <bie.Row className="align-items-center g-1">   {/* g-1 reduces gutter */}
                        <bie.Col xxl={1} xl={2} lg={2} md={3} sm={3} xs={4}>
                            <label className="mb-0"> Select District :</label>
                        </bie.Col>

                        <bie.Col xxl={4} xl={4} lg={4} md={6} sm={7} xs={8}>
                            <Field
                                as="select"
                                name="dist"
                                className="form-control form-control-md"
                                onChange={(e) => {
                                    fetchDistData(e.target.value);
                                    setColleges([]);
                                    DistFomik?.handleChange(e);
                                }}
                            >
                                <option value="">---select---</option>
                                {distlist?.map((d) => (
                                    <option key={d.dist_code} value={d.dist_code}>
                                        {d.dist_name}
                                    </option>
                                ))}
                            </Field>
                        </bie.Col>
                    </bie.Row>


                    {colleges?.length > 0 ? (<>


                        <div className='overal-stathead pt-5'>
                            <span> Project Status of {distname}</span>
                        </div>
                        <Box className="third-piechart-stepper">




                            <div className="piechart-legend-content">
                                <Box sx={{ width: 300, height: 300 }}>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={pieOptions}
                                    />
                                </Box>

                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1, minWidth: 150 }}>
                                    {distpiedata.map((e, i) => (
                                        <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Box
                                                sx={{
                                                    width: 14,
                                                    height: 14,
                                                    borderRadius: "50%",
                                                    backgroundColor: COLORSPie[e.project_status],
                                                }}
                                            />
                                            <Typography fontWeight={600}>
                                                {e.project_status}: {e.count}
                                            </Typography>
                                        </Box>
                                    ))}
                                    <Divider sx={{ my: 2 }} />
                                </Box>
                            </div>

                            <Box className="table-button-content" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                {/* Tabs */}
                                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                    {distpiedata.map((t) => {
                                        const active = activeTab === t.project_status;
                                        return (
                                            <Box className="buttons-table-data"
                                                key={t.project_status}
                                                onClick={() => setActiveTab(t.project_status)}
                                                sx={{
                                                    cursor: "pointer",
                                                    px: 2.5,
                                                    py: 1,
                                                    borderRadius: 1,
                                                    fontWeight: 600,
                                                    border: `2px solid ${COLORSPie[t.project_status]}`,
                                                    backgroundColor: active ? COLORSPie[t.project_status] : "transparent",
                                                    color: active ? "#fff" : COLORSPie[t.project_status],
                                                    transition: "0.2s",
                                                    flex: "1 1 32%",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {t.project_status} ({t.count})
                                            </Box>
                                        );
                                    })}
                                </Box>

                                <Box sx={{ mt: 2 }}>
                                    {colleges?.filter(c => c.status === activeTab).length ? (
                                        <TableContainer
                                            component={Paper}
                                            sx={{
                                                maxHeight: 400,
                                                border: "1px solid #ccc",  // blue border around whole table container
                                                borderRadius: 2,
                                                boxShadow: 0,
                                                overflow: "auto",
                                                borderBottom: "0px solid #ccc",
                                            }}
                                        >
                                            <Table
                                                stickyHeader
                                                sx={{
                                                    borderCollapse: "separate",
                                                    borderSpacing: 0,
                                                    boxShadow: 0,
                                                    //  border: "1px solid #ccc",  // blue border around table
                                                }}
                                            >
                                                {/* Table Header */}
                                                <TableHead>
                                                    <TableRow
                                                        sx={{
                                                            backgroundColor: "#ccc", // MUI primary blue
                                                            borderBottom: "1px solid #ccc",  // darker blue border below header
                                                        }}
                                                    >
                                                        <TableCell
                                                            sx={{
                                                                color: "#000",    //#4e2525ff
                                                                fontWeight: "bold",
                                                                borderRight: "1px solid #ccc",
                                                            }}
                                                        >
                                                            S.No
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                color: "#000",   //#4e2525ff
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            Institution Name
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {colleges
                                                        .filter((c) => c.status === activeTab)
                                                        .map((c, i) => (
                                                            <TableRow key={i} sx={{ backgroundColor: "#fff" }}>
                                                                <TableCell
                                                                    sx={{
                                                                        fontWeight: "bold",
                                                                        color: "#333",
                                                                        borderRight: "1px solid #ccc",
                                                                        borderBottom: "1px solid #ccc",
                                                                    }}
                                                                >
                                                                    {i + 1}
                                                                </TableCell>
                                                                <TableCell
                                                                    sx={{
                                                                        color: "#333",
                                                                        borderBottom: "1px solid #ccc",
                                                                    }}
                                                                >
                                                                    {c.institution_name}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    ) : (
                                        <Typography color="text.secondary">No colleges found</Typography>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    </>) : <>


                        {Errormsg === false && (
                            <div className="text-danger h5 pt-5 text-center">
                                ***** No Data Found *****
                            </div>
                        )}

                    </>}

                </Form>
            </FormikProvider >


        </>
    );




}
